import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { ordersRoutingModule } from './orders-routing.module';
import { ImportsPrimeModule } from 'src/app/_material/primeng.module';
import { SharedComponentsModule } from '../../shared/shared-components/shared-components.module';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { ordersComponent } from '../components/orders/orders.component';
import { AddordersComponent } from '../components/add-orders/add-orders.component';
import { draftOrdersComponent } from '../components/draft-order/draft-orders.component';


@NgModule({
  declarations: [
    ordersComponent,
    AddordersComponent,
    draftOrdersComponent
  ],
  imports: [
    CommonModule,
    ordersRoutingModule,
    FormsModule,
    ImportsPrimeModule,
    DatePipe,
    SharedModule,
    SharedComponentsModule
  ]
})
export class ordersModule { }
